// extracted by mini-css-extract-plugin
export default {"noteCard":"Region_noteCard__DHuMm","cardBody":"Region_cardBody__qYush","cardText":"Region_cardText__KiLr0"};